export const numberToCurrencyFormat = (value = 0) =>
    new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    }).format(value)

export const numberFormat = (value = 0) =>
    new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    })
        .format(value)
        .replace(/\D00$/, '')
